<!--
================================================
Composant gérant le formulaire de demande de réinitialisation de mot de passe
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="PwdRequestComp">
        <div class="columns mainContainer">

            <div class="column"></div>
            <div class="column is-three-quarters formColumn">

                <div class="columns">
                    <div class="column"></div>

                    <div class="column is-9 columnCont">
                        <img src="../assets/img/AppLogo.png" alt="Cronocloud App" width="164" height="29" class="logo">
                        <!--Formulaire de demande-->
                        <div class="contForm" v-if="!requestAchieved">
                            <!--<form action="" v-on:keyup.enter="validateBeforeSubmit"> !! bug étrange qui refresh la page avec ce code (mais qui fonctionne dans login/signup-->
                            <form action="" v-on:submit.prevent="validateBeforeSubmit" >

                                <h1 class="is-size-4">{{ $t("MdpOublié") }}</h1>

                                <div class="field">
                                    <div class="control">
                                        <input class="input" v-model="email"
                                               autocomplete="username"
                                               v-validate="'required|email|emailAvailabilityCheck'"
                                               data-vv-validate-on="change" id="pwdRequest_email"
                                               name="pwdRequest_email" type="email" v-bind:placeholder="$t('email')">
                                    </div>
                                    <p class="help is-danger has-text-left" id="error_pwdRequest_email">{{errors.first('pwdRequest_email') }}</p>
                                </div>

                                <i18n path="mdpOubliéInfos..." tag="span" class="infoLink">
                                    <a v-bind:href="supportEmail" target="_blank">{{ $t('contactezNotreSupport')}}</a>
                                </i18n>

                                <div class="field">
                                    <a v-on:click="validateBeforeSubmit" id="formSubmitBtn"
                                       v-bind:class="{'is-loading':isSubmiting}" class="button  is-fullwidth loginBtn">{{$t("Valider")}}</a>
                                </div>

                                <div class="alreadySigned">
                                    <span class="has-text-info">{{$t("PasEncoreInscrit")}} </span>
                                    <span class="has-text-link">
                                    <router-link id="signupLink"
                                                 v-bind:to="{ name: 'signup'}">{{$t("Inscrivez-vous")}}</router-link>
                                </span>
                                </div>

                            </form>
                        </div>

                        <!--Confirmation de la demande-->
                        <div class="contConfirm" v-if="requestAchieved">
                            <font-awesome-icon :icon="['far', 'check-circle']" size="6x" />
                            <h1 class="is-size-4">
                                {{ $t("DemandeEnregistrée") }}
                            </h1>

                            <div class="infoLink">
                                <span v-html="$t('requestConfirmMessage')"></span>
                            </div>

                          <router-link v-bind:to="{ name: 'login'}" class="backLink" >
                            {{ $t("retour") }}
                          </router-link>

                        </div>
                    </div>

                    <div class="column"></div>

                </div>
            </div>
            <div class="column"></div>

        </div>

    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import SentryMixin from "../mixins/SentryMixin.js";
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'SignupComp',
        components: {
        },
        mixins: [GlobalErrorNotification, SentryMixin, TrackingMixin],
        data: function () {
            return {
                supportEmail: 'mailto:'+ process.env.VUE_APP_SUPPORT_EMAIL, // lien mailto vers le support
                isSubmiting: false ,     // indique si le formulaire est en cours de soumission
                email: '', // email du compte dont on veut réinitialiser le pwd
                requestAchieved: false, // true si la requête de réinitialisation a été effectuée avec succès
            }
        },

        methods: {

            /*
            Envoi la requête pour demander une réinitialisation de mot de passe
            */
            sendPwdRequestQuery(){
                let self = this

                return self.$http
                    .post("public/password/request", {
                        email: self.email,
                        locale: this.$route.params.locale
                    })
                    .then(function () {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
                        self.requestAchieved = true;
                    })
                    .catch(function (error) {
                        self.logToSentry(self, error, 'error')
                        let errorCode = '0005'
                        self.showGlobalErrorNotif(self,errorCode)
                        self.$gtag.exception({'description': 'error '+errorCode + ' | error in password request query', 'fatal': false})

                        self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error in password request query"})
                        self.$sentry.captureMessage(`Error ${errorCode} > error in password request query : ${error}`, 'error')
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            },

            /*
             * Valide le formulaire avant sa soumission
             */
            validateBeforeSubmit() {
                this.$store.commit('UpdateGlobalNotificationCompVisibility', false); // on masque un éventuel message à la soumission
                this.isSubmiting = true;

                let self = this
                this.$validator.validateAll().then((result) => {
                    if (result) { // si la validation. réussie
                        self.sendPwdRequestQuery();
                        self.ga4GlobalEventTrack('Password requested' , {})

                      self.$mixpanel.track('Password requested', {"email":self.email})
                    }
                    else{ // si il y a des erreurs...
                        self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-danger',
                            'message': self.$t('leFormulaireContientDesErreurs')
                        });
                        self.isSubmiting = false;
                    }

                })
            },

            /*
             Retourne la disponibilité de l'adresse email
             (via une custom rule veeValidate)
             */
            validateEmailAvailability() {
                let self = this
                this.$validator.extend('emailAvailabilityCheck', {

                    getMessage() {
                        // récupération du message d'erreur dans le dictionnaire pour i18n
                        return self.$validator.dictionary.container[self.$validator.locale].custom_validator.pwd_request_email_not_found //pas top mais je n'ai pas trouvé mieux ! (inspiré de https://github.com/baianat/vee-validate/issues/745)

                    },
                    validate() {
                        return self.$http
                            .post("public/signup/email-available-check", {
                                email: self.email
                            })
                            .then(function (response) {
                              self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
                              if (response.data.message == "email is already used") {
                                     return {
                                         valid: true // la prop valid permet de valider le champs
                                     }
                                 }
                                 else {
                                     return {valid: false}
                                 }
                            })
                            .catch(function (error) {
                                self.logToSentry(self, error, 'error')
                                let errorCode = '0006'
                                self.showGlobalErrorNotif(self,errorCode)
                                self.$gtag.exception({'description': 'error '+errorCode + ' | error in password request email check query', 'fatal': false})
                              self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error in password request email check query"})
                                self.$sentry.captureMessage(`Error ${errorCode} > error in password request email check query : ${error}`, 'error')
                            })
                    }

                });
            },

            /*
             Affiche la modalTerms
             */
            openModalTerms() {
                this.$store.commit('UpdateModalTermsComp', {'isVisible': true})
            },

            /**
             * Définit la valeur de this.email si un paramètre email est présent dans l'url
             */
            preFillEmail(){
                if(this.$route.query.email){
                    this.email = this.$route.query.email
                }
            }


        },

        computed: mapState({}),

        created: function () {
            // activation des validateur custom pour invitation code et email
            this.validateEmailAvailability();
        },
        mounted: function () {
            this.preFillEmail()
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";

    .column {
        /*border: dashed 1px red;*/
    }

    .mainContainer {
        /*border :solid 3px gold;*/
        //  box-shadow:  0 -3px 5px $brandThird;
        @include mobile {
            padding: 0 1.5rem;
            margin-top: -3rem;
        }
    }

    .formColumn {
        padding: 3rem 1rem;
        background: #f3f3f3;
        border-radius: 3px;

        .logo {
            margin-bottom: 4rem;
        }

        h1 {
            color: $brandThird;
            /*font-size: 2rem;*/
        }
        .input {
            margin-top: 2rem;
        }
        .loginBtn {
            margin-top: 4rem;
            padding: 2rem 0;
            border: solid 1px transparent;
            background: $brandPrimary;
            color: white;
            &:hover {
                transition: background-color 0.3s;
                background: lighten($brandPrimary, 5%);
                color: white;
            }
            &:active {
                background: $brandBlue;
                transition: background-color 0.1s;
                color: white;
            }

        }
        .infoLink {
            font-style: italic;
            font-size: 0.9rem;
            padding-top: 1rem;
            $color: #839ba6;
            color: $color;
            a {
                color: $color;
                text-decoration: underline
            }
        }


        .columnCont {
            @include mobile {
                padding: 0 2rem;
            }
        }
        .alreadySigned {
            margin: 3rem 0 0;
            a {
                text-decoration: underline
            }

        }

    }

    .contConfirm{
        .infoLink{
            font-size: 1rem;
            font-style: normal;
        }

        .backLink{
          margin: 2rem auto;
          //background-color: red;
          display: block;
          &:before{
            content: "<";
          }
        }
        .svg-inline--fa{
            color: $brandPrimary;
            margin-bottom: 2rem;
        }




    }

</style>
